export const AllSelectRoutes = {
  index: "/select",
};
